import { Route, Switch } from "react-router-dom";

import OnboardingProductsSliderPage from "@faire/prototype-playground/workspace/ajr/onboarding-products-slider";

export function AjaybirRatoulRoutes() {
  return (
    <Switch>
      <Route path="/ajr/onboarding-products-slider" component={OnboardingProductsSliderPage} />
    </Switch>
  );
}

export const slug = "ajr";
